module.exports = __webpack_public_path__ + "static/discount4-6ec9ae325c91a881ca2f5060bbf76be0.jpg";